import { FC } from "react";
import { useTranslation } from "react-i18next";

import { RIDE_INVESTIGATION_SEVERITY_COLOR } from "../investigation.constants";
import { IPlaybackModel } from "../investigation.models";
import {
  AnomalyBannerStyled,
  AnomalyListStyled,
  AnomalyRowStyled,
  PanelSectionTitleStyled,
} from "../investigation.panel.styled";
import { anomalyMeta } from "../investigation.utils";

/** "What went wrong" banner — always visible above the tabs when anomalies exist. */
export const InvestigationAnomalies: FC<{ model: IPlaybackModel }> = ({
  model,
}) => {
  const { t } = useTranslation();
  const anomalies = model.payload.anomalies;

  if (!anomalies.length) {
    return null;
  }

  return (
    <AnomalyBannerStyled>
      <PanelSectionTitleStyled>
        {t("rideMap.investigation.anomaly.title")}
      </PanelSectionTitleStyled>
      <AnomalyListStyled>
        {anomalies.map((anomaly, index) => (
          <AnomalyRowStyled
            key={`${anomaly.type}-${index}`}
            $color={RIDE_INVESTIGATION_SEVERITY_COLOR[anomaly.severity]}
          >
            <span className="anomaly-dot" />
            <span>
              {t(anomaly.labelKey)}
              {anomalyMeta(anomaly)}
            </span>
          </AnomalyRowStyled>
        ))}
      </AnomalyListStyled>
    </AnomalyBannerStyled>
  );
};
